/* eslint-disable @typescript-eslint/no-unused-vars */
// /* eslint-disable @typescript-eslint/no-unused-vars */
import Select from 'react-select';
import { AuthUser, Tooltips } from 'Components/Common/Util';
import * as url from '../../helpers/url_helper';
import scclLogo from '../../assets/images/commons/scclLogo.svg';

import withRouter from 'Components/Common/withRouter';
import { useEffect, useRef, useState } from 'react';

const ThreeDTool = (props: any) => {
    const windowItmes: any = window;
    const api = props.router.apiClient;
    const { state } = props.router.location;

    if (!state) {
        window.location.href = '/#/login';
    }
    const { label, value, data } = state || {};

    const roles = AuthUser()?.userProfile?.roles;
    const role = roles?.[0]?.role;

    const cesiumContainerRef = useRef(null);
    const [isReset, setIsReset] = useState(false);
    const [source3dOptions, setSource3dOptions] = useState([]);
    const [selected, setSelected] = useState({ value: '' });
    useEffect(() => {
        if (role === 'USER') {
            getSources3D();
        } else {
            getGuestSources3D();
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    const getSources3D = () => {
        // setLoading(true);
        api.get(url.GET_SOURCE3D(value))
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    let data = resp?.data?.data;
                    if (data) {
                        data = [resp?.data?.data];
                    } else {
                        data = [];
                    }
                    let options = data?.map((val: any) => ({
                        label: val?.fileName,
                        value: process.env.REACT_APP_API_URL + '/files/view/' + val?.fileURL
                    }));
                    setSource3dOptions(options);
                    setSelected(options[0]);
                }
            })
            .catch(() => {
                // setLoading(false);
            });
    };

    const getGuestSources3D = () => {
        const payLoad = {
            params: { openAccess: true }
        };
        api.get(url.GET_GUEST_SOURCES3D(value), payLoad)
            .then((resp: any) => {
                if (resp?.status?.toLowerCase() === 'success' && resp?.data) {
                    let data = resp?.data?.data;
                    if (data) {
                        data = [resp?.data?.data];
                    } else {
                        data = [];
                    }
                    let options = data?.map((val: any) => ({
                        label: val?.fileName,
                        value: process.env.REACT_APP_API_URL + '/files/view/' + val?.fileURL
                    }));
                    setSource3dOptions(options);
                    setSelected(options[0]);
                }
            })
            .catch(() => {
                // setLoading(false);
            });
    };

    useEffect(() => {
        if (!windowItmes.Cesium) {
            console.error('CesiumJS not loaded');
            return;
        }
        windowItmes.Cesium.Ion.defaultAccessToken = null;
        const CartoAttribution =
            'Map tiles by <a href="https://carto.com">Carto</a>, under CC BY 3.0. Data by <a href="https://www.openstreetmap.org/">OpenStreetMap</a>, under ODbL.';
        const imageryViewModels = [
            new windowItmes.Cesium.ProviderViewModel({
                name: 'OpenStreetMap',
                iconUrl: windowItmes.Cesium.buildModuleUrl('Widgets/Images/ImageryProviders/openStreetMap.png'),
                tooltip:
                    'OpenStreetMap (OSM) is a collaborative project to create a free editable map of the world.\nhttp://www.openstreetmap.org',
                creationFunction: () =>
                    new windowItmes.Cesium.UrlTemplateImageryProvider({
                        url: 'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
                        subdomains: 'abc',
                        minimumLevel: 0,
                        maximumLevel: 19
                    })
            }),
            new windowItmes.Cesium.ProviderViewModel({
                name: 'Positron',
                tooltip: 'CartoDB Positron basemap',
                iconUrl: 'http://a.basemaps.cartocdn.com/light_all/5/15/12.png',
                creationFunction: () =>
                    new windowItmes.Cesium.UrlTemplateImageryProvider({
                        url: 'http://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}.png',
                        credit: CartoAttribution,
                        minimumLevel: 0,
                        maximumLevel: 18
                    })
            }),
            new windowItmes.Cesium.ProviderViewModel({
                name: 'Positron without labels',
                tooltip: 'CartoDB Positron without labels basemap',
                iconUrl: 'http://a.basemaps.cartocdn.com/rastertiles/light_nolabels/5/15/12.png',
                creationFunction: () =>
                    new windowItmes.Cesium.UrlTemplateImageryProvider({
                        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/light_nolabels/{z}/{x}/{y}.png',
                        credit: CartoAttribution,
                        minimumLevel: 0,
                        maximumLevel: 18
                    })
            }),
            new windowItmes.Cesium.ProviderViewModel({
                name: 'Dark Matter',
                tooltip: 'CartoDB Dark Matter basemap',
                iconUrl: 'http://a.basemaps.cartocdn.com/rastertiles/dark_all/5/15/12.png',
                creationFunction: () =>
                    new windowItmes.Cesium.UrlTemplateImageryProvider({
                        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/dark_all/{z}/{x}/{y}.png',
                        credit: CartoAttribution,
                        minimumLevel: 0,
                        maximumLevel: 18
                    })
            }),
            new windowItmes.Cesium.ProviderViewModel({
                name: 'Dark Matter without labels',
                tooltip: 'CartoDB Dark Matter without labels basemap',
                iconUrl: 'http://a.basemaps.cartocdn.com/rastertiles/dark_nolabels/5/15/12.png',
                creationFunction: () =>
                    new windowItmes.Cesium.UrlTemplateImageryProvider({
                        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/dark_nolabels/{z}/{x}/{y}.png',
                        credit: CartoAttribution,
                        minimumLevel: 0,
                        maximumLevel: 18
                    })
            }),
            new windowItmes.Cesium.ProviderViewModel({
                name: 'Voyager',
                tooltip: 'CartoDB Voyager basemap',
                iconUrl: 'http://a.basemaps.cartocdn.com/rastertiles/voyager_labels_under/5/15/12.png',
                creationFunction: () =>
                    new windowItmes.Cesium.UrlTemplateImageryProvider({
                        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_labels_under/{z}/{x}/{y}.png',
                        credit: CartoAttribution,
                        minimumLevel: 0,
                        maximumLevel: 18
                    })
            }),
            new windowItmes.Cesium.ProviderViewModel({
                name: 'Voyager without labels',
                tooltip: 'CartoDB Voyager without labels basemap',
                iconUrl: 'http://a.basemaps.cartocdn.com/rastertiles/voyager_nolabels/5/15/12.png',
                creationFunction: () =>
                    new windowItmes.Cesium.UrlTemplateImageryProvider({
                        url: 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager_nolabels/{z}/{x}/{y}.png',
                        credit: CartoAttribution,
                        minimumLevel: 0,
                        maximumLevel: 18
                    })
            }),
            new windowItmes.Cesium.ProviderViewModel({
                name: 'National Map Satellite',
                iconUrl: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/4/6/4',
                creationFunction: () =>
                    new windowItmes.Cesium.UrlTemplateImageryProvider({
                        url: 'https://basemap.nationalmap.gov/arcgis/rest/services/USGSImageryOnly/MapServer/tile/{z}/{y}/{x}',
                        credit: 'Tile data from <a href="https://basemap.nationalmap.gov/">USGS</a>',
                        minimumLevel: 0,
                        maximumLevel: 16
                    })
            })
        ];
        const viewer = new windowItmes.Cesium.Viewer(cesiumContainerRef.current, {
            // imageryProviderViewModels: imageryViewModels,
            // selectedImageryProviderViewModel: imageryViewModels[1],
            animation: false,
            timeline: false,
            infoBox: false,
            homeButton: false,
            fullscreenButton: true,
            selectionIndicator: false,
            scene3DOnly: false,
            vrButton: false,
            sceneModePicker: false
        });
        viewer.baseLayerPicker.viewModel.terrainProviderViewModels.removeAll();
        const tileset = new windowItmes.Cesium.Cesium3DTileset({
            url: selected?.value,
            maximumScreenSpaceError: 1
        });
        tileset.readyPromise
            .then(function (tileset: any) {
                // Set initial camera view
                viewer.zoomTo(tileset);
            })
            .otherwise(function (error: any) {
                console.error('Failed to load tileset:', error);
            });
        viewer.scene.primitives.add(tileset);
        viewer.zoomTo(tileset);
        setIsReset(false);
        return () => {
            if (viewer) {
                viewer.destroy();
            }
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selected, isReset === true]);

    const selectChange = (e: any) => {
        setSelected(e);
    };
    const reset = () => {
        setIsReset(true);
    };

    return (
        <div>
            <div className="client-header" style={{ height: '70px' }}>
                <div className="drogo-logo">
                    {/* <img src={scclLogo} alt="sccl-logo" width="100%" /> */}
                </div>
            </div>
            <div id="cesiumContainer" ref={cesiumContainerRef} style={{ width: '100%', height: '100vh' }}></div>
            <div className="xsd">
                <Select options={source3dOptions} width="100" value={selected} onChange={(val: any) => selectChange(val)} />
            </div>
            <div className="btn-3d fs-3 pointer">
                <i className="bx bx-reset" onClick={reset} id="reset"></i>
                {Tooltips('reset', 'Reset', 'bottom')}
            </div>
        </div>
    );
};

export default withRouter(ThreeDTool);
